module.exports = __webpack_public_path__ + "media/images/emblems/Adligenswil_LU-3e3ee249952f110770762e78e5437726.png";